import React from 'react';
import { Switch, Redirect } from 'react-router-dom';
import { createMuiTheme, ThemeProvider } from '@material-ui/core/';

import Dashboard from './views/Dashboard';
import ManageEvents from './views/ManageEvents';
import SignIn from './views/SignIn';
import SignUp from './views/SignUp';
import ResetPassword from './views/ResetPassword';

import LoadingScreen from './components/LoadingScreen';

import { AuthProvider, useAuth } from './utils/useAuth';

const ProtectedRoute = ({ component: Component, ...rest }) => {
  const { user, userIsLoading } = useAuth();
  if (userIsLoading) {
    return <LoadingScreen />;
  }

  return user ? (
    <Component {...rest} />
  ) : (
    <Redirect
      to={{ pathname: '/signin', state: { from: rest.path } }}
      noThrow
    />
  );
};

const PublicRoute = ({ component: Component, ...rest }) => (
  <Component {...rest} />
);

const theme = createMuiTheme({ palette: { primary: { main: '#7043B6' } } });

function App() {
  return (
    <AuthProvider>
      <ThemeProvider theme={theme}>
        <Switch>
          <ProtectedRoute
            exact
            path="/manage-events"
            component={ManageEvents}
          />
          <ProtectedRoute exact path="/" component={Dashboard} />
          <PublicRoute path="/signin" component={SignIn} />
          <PublicRoute path="/signup" component={SignUp} />
          <PublicRoute path="/password-reset" component={ResetPassword} />
        </Switch>
      </ThemeProvider>
    </AuthProvider>
  );
}

export default App;
